import { CmsAvailabilityNotification } from '../../interface';
import { ButtonLinkColorVariant, IButtonLinkProperties, OptIconPosition } from '@vfde-brix/ws10/button-link';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { AvailabilityResultLink } from '../../container/AddressValidation/enum';
import { NotificationState } from '@vfde-brix/ws10/notification-icon';
import { ProductAvailability } from '../../container/AddressValidation/interface';

const getResultState = (isCableTvAvailable: boolean): NotificationState =>
    isCableTvAvailable ? 'success' : 'warn';

const getResultHeadline = ({ headline }: CmsAvailabilityNotification, isCableTvAvailable: boolean) =>
    isCableTvAvailable ? headline.available : headline.notAvailable;

const getResultSubline = ({ subline }: CmsAvailabilityNotification, availability: ProductAvailability) => {
    if (availability.cableTv && availability.tvConnect) {
        return subline.available;
    }

    if (availability.homesPassed) {
        return subline.homesPassed;
    }

    return '';
};

const getResultContainerButtons = ({ button }: CmsAvailabilityNotification, availability: ProductAvailability): IButtonLinkProperties[] | undefined => {
    if (!availability.homesPassed) {
        return undefined;
    }

    return [{
        optColorVariant: ButtonLinkColorVariant.Primary200,
        stdLabel: button.homesPassed,
        business: NO_PATTERN_BUSINESS_LOGIC,
        linkHref: AvailabilityResultLink.HOMES_PASSED,
        optIconPosition: OptIconPosition.RIGHT,
        optTarget: '_self',
        stdSystemIconName: 'chevron-right',
        type: 'ButtonLink',
        optDisabled: false,
    }];
};

export default {
    getResultState,
    getResultHeadline,
    getResultSubline,
    getResultContainerButtons,
};
